export const trimObjectValues = <T extends Record<string, any>>(data: T): T => {
  const trimmed: Record<string, any> = {};

  for (const [key, value] of Object.entries(data)) {
    if (typeof value === "string") {
      trimmed[key] = value.trim();
    } else if (value !== null && typeof value === "object" && !Array.isArray(value)) {
      trimmed[key] = trimObjectValues(value);
    } else {
      trimmed[key] = value;
    }
  }

  return trimmed as T;
};
